import { all, call, delay, fork, put, takeLeading, select, takeLatest, takeEvery } from 'redux-saga/effects'
import * as types from 'store/types'
import * as apis from 'store/apis'
import * as actions from 'store/actions'
import { consoleLog, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { history } from 'store/store'
import { toast } from 'react-toastify'

function* getDrafts_saga({ resolve, reject }) {
  try {
    const data = yield call(apis.getDrafts_api)
    yield put(actions.setDrafts_action(data))
    yield delay(500)
    resolve && resolve()
  } catch (error) {
    // handleApiError(error)
    reject && reject()
  }
}
function* getContents_saga({ filters, resolve, reject }) {
  try {
    yield put(actions.setLoadingCategoryId_action(filters?.category_uuid))
    const data = yield call(apis.getContents_api, filters || {})
    yield put(actions.setContents_action(data, filters))
    yield delay(500)
    resolve && resolve()
  } catch (error) {
    consoleLog(error)
    reject && reject()
  }
}
function* createDrafts_saga({ data, resolve, reject, isEditing }) {
  try {
    const isLimitReached = yield select(
      (state) => !state.company.company.isFree && !state.subscription.is_subscribed && !state.company.company.isOnGracePeriod && state.app.total_items_count >= state.company.company.free_items_limit
    )
    if (!isEditing && isLimitReached) {
      yield put(actions.toggleSettingsModal_action(true))
      yield put(actions.changeTab_action('billing'))
      history.push('/')
      reject()
    } else {
      const result = yield call(apis.createDraft_api, data)
      yield put(actions.getDrafts_action())
      yield put(actions.getTotalItemsCount_action())
      yield delay(500)
      resolve && resolve(result)
    }
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}
function* saveCategory_saga({ data, resolve, reject }) {
  try {
    let category
    if (!data.uuid) {
      category = yield call(apis.createCategory_api, data)
    } else {
      category = yield call(apis.updateCategory_api, data)
    }
    resolve && resolve(category)
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}
function* getCategories_saga({ resolve, reject }) {
  try {
    const data = yield call(apis.getCategories_api)
    yield put(actions.setCategories_action(data))
    resolve && resolve()
  } catch (error) {
    // handleApiError(error)
    reject && reject()
  }
}
function* getPrivateAndFavoriteContents_saga({ filters, resolve, reject }) {
  try {
    const data = yield call(apis.getPrivateAndFavoriteContents_api, filters)
    yield put(actions.setPrivateAndFavoriteContents_action(data, filters.type))
    resolve && resolve()
  } catch (error) {
    consoleLog(error)
    reject && reject()
    // handleApiError(error)
  }
}
function* saveContent_saga({ data, resolve, reject }) {
  try {
    const submitData = { ...data }
    if (data.category_id) {
      submitData.category = JSON.stringify(data.category)
    }
    if (!submitData.uuid) {
      if (
        yield select(
          (state) => !state.company.company.isFree && !state.subscription.is_subscribed && !state.company.company.isOnGracePeriod && state.app.total_items_count >= state.company.company.free_items_limit
        )
      ) {
        yield put(actions.toggleSettingsModal_action(true))
        yield put(actions.changeTab_action('billing'))
        history.push('/')
        reject()
      } else {
        yield call(apis.createContent_api, data)
        yield put(actions.getTotalItemsCount_action())
      }
    } else {
      yield call(apis.updateContent_api, data, data.uuid)
    }
    if (data.category?.uuid) {
      yield put(actions.getContents_action({ category_uuid: data.category?.uuid, type: data.type }))
    } else {
      yield put(actions.getPrivateAndFavoriteContents_action({ type: data.type }))
    }
    resolve && resolve()
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}
function* importResponsesFromTray_saga({ resolve, reject }) {
  try {
    yield call(apis.importResponsesFromTray_api)
    const user = yield select((state) => state.auth.user)
    yield put(actions.updateUser_action({ ...user, tray_new_response_count: 0 }))
    resolve && resolve()
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}
function* getRecentlyVeiwedContent_saga() {
  try {
    const result = yield call(apis.recentlyViewedContent_api)
    yield put(actions.setRecentlyViewedContent_action(result))
  } catch (error) {
    consoleLog(error)
  }
}
function* markAsFavorite_saga({ content }) {
  try {
    yield call(apis.markAsFavorite_api, content.uuid)
    yield put(actions.getPrivateAndFavoriteContents_action({ type: content.type }))
  } catch (error) {
    consoleLog(error)
  }
}
function* pinToCategory_saga({ content, resolve, reject }) {
  try {
    yield call(apis.pinToCategory_api, content.uuid)
    logAmplitudeEvent('Pinned To Category')
    yield put(actions.getContents_action({ category_uuid: content.category?.uuid, type: content.type }))
    resolve && resolve()
  } catch (error) {
    consoleLog(error)
    reject && reject(error)
  }
}

function* saveIconCoverImage_saga({ payload }) {
  yield put(actions.setIsRequestCallComplete(false));
  yield put(actions.setErrorBag({}));

  try {
   const saveMedia = yield call(apis.createIconAndCoverImage, payload);
   yield put(actions.setIsRequestCallComplete(true));
   toast.success(saveMedia?.message)
  } catch (error) {
    yield put(actions.setIsRequestCallComplete(true));
    yield put(actions.setErrorBag(error));
    handleApiError(error)
  }
}

function* deleteIconCoverImage_saga({ payload }) {
  yield put(actions.setIsRequestCallComplete(false));
  yield put(actions.setErrorBag({}));

  try {
   const deleteMedia = yield call(apis.deleteIconAndCoverImage, payload);
   yield put(actions.setIsRequestCallComplete(true));
   toast.success(deleteMedia?.message)
  } catch (error) {
    yield put(actions.setIsRequestCallComplete(true));
    yield put(actions.setErrorBag(error));
    handleApiError(error)
  }
}

function* repositionCoverImage_saga({ payload }) {
  yield put(actions.setIsRequestCallComplete(false));

  try {
   const repositionCover = yield call(apis.repositionCoverImage, payload);
   yield put(actions.setIsRequestCallComplete(true));
   toast.success(repositionCover?.message)
  } catch (error) {
    yield put(actions.setIsRequestCallComplete(true));
    handleApiError(error)
  }
}

export function* watchSagas() {
  yield takeLeading(types.SAVE_CONTENT, saveContent_saga)
  yield takeEvery(types.GET_CONTENTS, getContents_saga)
  yield takeLatest(types.GET_CATEGORIES, getCategories_saga)
  yield takeLatest(types.GET_DRAFTS, getDrafts_saga)
  yield takeEvery(types.GET_PRIVATE_AND_FAVORITE_CONTENT, getPrivateAndFavoriteContents_saga)
  yield takeLeading(types.SAVE_CATEGORY, saveCategory_saga)
  yield takeLeading(types.CREATE_DRAFT, createDrafts_saga)
  yield takeLeading(types.IMPORT_TRAY_CONTENT, importResponsesFromTray_saga)
  yield takeLeading(types.GET_RECENT_VIEWED_CONTENT, getRecentlyVeiwedContent_saga)
  yield takeLeading(types.MARK_AS_FAVORITE, markAsFavorite_saga)
  yield takeLeading(types.PIN_TO_CATEGORY, pinToCategory_saga)
  yield takeLeading(types.SAVE_ICON_COVER_IMAGE, saveIconCoverImage_saga)
  yield takeLeading(types.DELETE_ICON_COVER_IMAGE, deleteIconCoverImage_saga)
  yield takeLeading(types.REPOSITION_COVER_IMAGE, repositionCoverImage_saga)
}

export default function* contentsSagas() {
  yield all([fork(watchSagas)])
}
